
import {SaseungHangulService} from "./saseung-hangul.service";

export const SaseungHangulInjectables: Array<any> = [
  {
    provide: SaseungHangulService,
    useClass: SaseungHangulService,
  },
];
